import type { CommandItemType } from '@/models/operator';

export const signOnCommands: CommandItemType[] = [
  { command: 'operations', label: 'Operations' },
  { command: 'delivery', label: 'Delivery', role: 'delivery-operator' },
  { command: 'lossPrevention', label: 'Loss Prevention', role: 'lossPrevention' },
  { command: 'qualityAssurance', label: 'Quality Assurance', role: 'qualityAssurance' },
  { command: 'partnership', label: 'Partnership', role: 'partnership-operator' },
  { command: 'homeServices', label: 'Home Services', role: 'homeServices-operator' },
  { command: 'facebookHomeServices', label: 'Facebook & Home Services', role: 'facebookHomeServices' },
  { command: 'lossPreventionGourmet', label: 'Loss Prevention Gourmet', role: 'lossPreventionGourmet' },
  { command: 'lossPreventionGrocery', label: 'Loss Prevention Grocery', role: 'lossPreventionGrocery' },
  { command: 'virtualAssistanceGrocery', label: 'Virtual Assistance Grocery', role: 'virtualAssistanceGrocery' },
  { command: 'supervisor', label: 'Supervisor', role: 'supervisor' },
  {
    command: 'ride-registrations',
    label: 'Ride Registrations',
    role: 'teamLead,affiliate-manager,director,admin,ride-registrations-operator',
  },
  {
    command: 'gourmet-registrations',
    label: 'Gourmet Registrations',
    role: 'teamLead,affiliate-manager,director,admin,gourmet-registrations-operator',
  },
  {
    command: 'grocery-registrations',
    label: 'Grocery Registrations',
    role: 'teamLead,affiliate-manager,director,admin,grocery-registrations-operator',
  },
  {
    command: 'delivery-registrations',
    label: 'Delivery Registrations',
    role: 'teamLead,affiliate-manager,director,admin,delivery-registrations-operator',
  },
  {
    command: 'pharmacy-registrations',
    label: 'Pharmacy Registrations',
    role: 'teamLead,affiliate-manager,director,admin,pharmacy-registrations-operator',
  },
  {
    command: 'homeServices-registrations',
    label: 'Home Services Registrations',
    role: 'teamLead,affiliate-manager,director,admin,homeServices-registrations-operator',
  },
  { command: 'pharmacy', label: 'Pharmacy', role: 'pharmacy-operator' },
  { command: 'gogocare', label: 'GoGo Care', role: 'gogocare-operator' },
  { command: 'research-study', label: 'Research Study', role: 'research-operator' },
  { command: 'gogo-welcome', label: 'GoGo Welcome', role: 'gogo-welcome-operator' },
  {
    command: 'gogocare-registrations',
    label: 'GoGo Care Registrations',
    role: 'teamLead,affiliate-manager,director,admin,gogocare-registrations-operator',
  },
  {
    command: 'partnership-registrations',
    label: 'Partnership Registrations',
    role: 'teamLead,affiliate-manager,director,admin,partnership-registrations-operator',
  },
  {
    command: 'research-study-registrations',
    label: 'Research Study Registrations',
    role: 'teamLead,affiliate-manager,director,admin,research-registrations-operator',
  },
  { command: 'partnership-caller-operations', label: 'Partnership Caller', role: 'partnership-caller-operator' },
  {
    command: 'partnership-caller-registrations',
    label: 'Partnership Caller Registrations',
    role: 'teamLead,affiliate-manager,director,admin,partnership-caller-registrations-operator',
  },
  {
    command: 'facebookLeads-registrations',
    label: 'Facebook Registrations',
    role: 'teamLead,affiliate-manager,director,admin,facebookLeads-registrations-operator',
  },
  {
    command: 'facebook-and-rides',
    label: 'Facebook and Rides',
    role: 'teamLead,affiliate-manager,director,admin,facebookLeads-registrations-operator',
  },
];

export const signOffCommands: CommandItemType[] = [
  { command: 'callback', label: 'Calling back', isReasonRequired: true },
  { command: 'coaching', label: 'Meeting', isReasonRequired: true },
  { command: 'technical', label: 'Technical issues', isReasonRequired: true },
  { command: 'lunch', label: 'Going for lunch' },
  { command: 'restroom', label: 'Restroom break' },
  { command: 'break', label: 'Other break' },
  { command: 'moretimefor', label: 'Need more time', isReasonRequired: true },
  { command: 'logoutlogin', label: 'Log Out Log In', isReasonRequired: false },
  { command: 'offline', label: 'Sign Off' },
  { command: 'callissue', label: 'Call Issue', hidden: true },
  { command: 'off-call', label: 'Off Call', hidden: true },
];

export const onboardingSignOffCommands: CommandItemType[] = [
  { command: 'break', label: 'Break' },
  { command: 'coaching', label: 'Meeting' },
  { command: 'restroom', label: 'Restroom break' },
  { command: 'technical', label: 'Technical issues' },
];

// Hardcoded list of operators. If this gets changed frequently we can consider storing this info in the database, e.g. as a field in operator.data.
export const operatorsAllowedToSkipFreeTrial = ['c706c2bf-a483-48db-812b-1e000a554974', 'ab0d6f76-9883-11e8-88a2-42010a800012'];
